import type { FC } from 'react';
import { CoinPage } from './CoinPage';

export const CoinBuyPage: FC = () => {
  return <CoinPage type="buy" />;
};

export const CoinPricePage: FC = () => {
  return <CoinPage type="price" />;
};
